import { render, staticRenderFns } from "./ChangePrice.vue?vue&type=template&id=a8e197f2&"
import script from "./ChangePrice.vue?vue&type=script&lang=js&"
export * from "./ChangePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports